<script setup lang="ts">
import { withDefaults, defineProps } from 'vue'

interface AdItem {
  text: string
  url?: string
}

interface Props {
  ads?: AdItem[]
  speed?: number
  direction?: 'left' | 'right'
  textColor?: string
  backgroundColor?: string
}
//{ text: '醫才認證 計嘉恩醫創', url: 'https://demo2.eztrust.tw/KGE/page/contact/index.aspx?num=1&lang=TW' },

const props = withDefaults(defineProps<Props>(), {
  ads: () => [    
    { text: '每天不到一杯咖啡錢，絕對清晰' },
    { text: '!!! Ultra HD 4K 專用鏡頭' },
    { text: '遊戲都4K了 你還在..只有清晰沒有糾紛' },        
    { text: '智能入貨出庫維修備查錄影' },       
    { text: '電商出貨錄影系統' },
    { text: '歡迎提案商業合作開發' },
    { text: '系統整合 虔智科技', url: 'https://qianchih.net' }, 
  ],  
  speed: 100,
  direction: 'left',
  textColor: '#ffffff',
  backgroundColor: '#000000'
})
</script>

<template>
  <div
    class="Banner"
    :style="{ backgroundColor: props.backgroundColor }"
  >
    <div class="marquee">
      <div
        class="marquee-content"
        :class="{ 'direction-right': props.direction === 'right' }"
        :style="{ animationDuration: `${props.speed}s` }"
      >
        <!-- 第1次 -->
        <span
          v-for="(line, index) in props.ads"
          :key="index"
          class="ad-item"
        >
          <a
            v-if="line.url"
            :href="line.url"
            target="_blank"
            rel="noopener"
            style="color: #06c755; text-decoration: none;"
          >
            {{ line.text }}
          </a>
          <template v-else>
            <span :style="{ color: props.textColor }">{{ line.text }}</span>
          </template>
          　　
        </span>

        <!-- 複製一份銜接無縫滾動 -->
        <span
          v-for="(line, index) in props.ads"
          :key="'clone-' + index"
          class="ad-item"
        >
          <a
            v-if="line.url"
            :href="line.url"
            target="_blank"
            rel="noopener"
            style="color: yellow; text-decoration: none;"
          >
            {{ line.text }}
          </a>
          <template v-else>
            <span :style="{ color: props.textColor }">{{ line.text }}</span>
          </template>
          　　
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.Banner {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 2.5rem;
  box-sizing: border-box;
}

.marquee {
  width: 100%;
  overflow: hidden;
}

.marquee-content {
  display: inline-block;
  white-space: nowrap;
  position: absolute;
  will-change: transform;
  animation: scroll-left linear infinite;
}

.marquee-content.direction-right {
  animation: scroll-right linear infinite;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes scroll-right {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
}

.ad-item {
  margin-right: 2rem;
  font-size: 2rem;
  font-weight: 500;
  display: inline-block;
  letter-spacing: 0.5px;
}
</style>
